module.exports = __webpack_public_path__ + "img/3.8b83c0c5.png";